module.exports = __webpack_public_path__ + "img/red.2903dda6.png";